import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useMutation } from '@apollo/react-hooks';
import {
  UpdateGoogleAdGroupsStatus,
  UpdateGoogleAdGroupsStatusVariables
} from './__generated__/UpdateGoogleAdGroupsStatus';

const UPDATE_GOOGLE_AD_GROUPS_STATUS_MUTATION = gql`
  mutation UpdateGoogleAdGroupsStatus($googleAdGroupIds: [ID!]!, $status: GoogleStatusEnum!) {
    updateGoogleAdGroupsStatus(googleAdGroupIds: $googleAdGroupIds, status: $status) {
      googleAdGroups {
        id
        status
      }
      errors
    }
  }
`;

export const useUpdateGoogleAdGroupsStatus = () => {
  return useMutation<UpdateGoogleAdGroupsStatus, UpdateGoogleAdGroupsStatusVariables>(
    UPDATE_GOOGLE_AD_GROUPS_STATUS_MUTATION,
    { client: kmsClient }
  );
};
